import { Component } from "@angular/core"

@Component({
  standalone: true,
  imports: [],
  templateUrl: "./unknown.page.html",
  styleUrl: "./unknown.page.scss",
})
export class UnknownPageComponent {}
